import axios from "@/plugins/axios";

let url = "/api/console/setting";

export default {
    getSetting(){
        return axios.get(url).then(result => result.data);
    },
    putSetting(data){
        return axios.put(url, data).then(result => result.data);
    }
}
